/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';

import IconClose from '../../icons/IconClose';

class SearchForm extends React.Component {

  constructor(props) {
    super(props);
    this.clearField = this.clearField.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  componentDidMount() {
    if (this.props.hasInitialFocus) {
      this.inputRef.focus();
    }
  }

  onSubmit(event) {
    event.preventDefault();
    this.inputRef.blur();
    this.props.submitSearch();
  }

  clearField() {
    this.props.clearField();
    this.inputRef.focus();
  }

  render() {
    return (
      <form onSubmit={this.onSubmit}>
        <div className="cmp-searchfield">
          <input
            ref={(inp) => { this.inputRef = inp; }}
            autoComplete="off"
            name="searchQuery"
            onFocus={this.onFocus}
            onChange={this.props.onChange}
            value={this.props.value}
            placeholder={this.props.intl.formatMessage({ id: this.props.placeholder })}
          />

          <div className="cmp-searchfield-clear" onClick={this.clearField}>
            <IconClose.Small color="white" />
          </div>
        </div>
      </form>
    );
  }
}
SearchForm.propTypes = {
  intl: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  submitSearch: PropTypes.func.isRequired,
  clearField: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  hasInitialFocus: PropTypes.bool,
};

export default injectIntl(SearchForm);
